import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/service-shift-work";

export const pagingServiceShiftWork = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);

export const getServiceShiftWorkById = (id) =>
  axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdate = (serviceShiftWork) =>
  axios.post(API_PATH + "/save-or-update", serviceShiftWork);

export const deleteServiceShiftWork = (id) =>
  axios.delete(API_PATH + "/mark-delete/" + id);

export const getAllServiceShiftWork = () => axios.get(API_PATH + "/get-all");
